export default {
  for_individuals: "Jismoniy shaxslar uchun",
  for_legal_entities: "Yuridik shaxslar uchun",
  tracking: "Kuzatish",
  shipment: "Jo'natma",
  tariffs: "Tariflar",
  services: "Xizmatlar",
  online_services: "Onlayn xizmatlar",
  one_step: "Bir Qadam",
  delivery_description: "Доставка отправлений по всему Узбекистану в течении 1 ДНЯ",
  service_details: "Xizmat haqida batafsil",
  branch_map: "\"Bir Qadam\" bo'limlari xaritasi",
  search_branch: "Pochta bo'limni qidirish",
  news: "Yangiliklar",
  shipment_calculator: "Jo'natma kalkulyatori",
  online_registration: "Jo'natmani onlayn rasmiylashtirish",
  my_post_index: "Mening pochta indeksim",
  send_inquiry: "Murojaat yuborish",
  more_details: "Batafsil",
  personal_cabinet: "Shaxsiy kabinet",
  types_of_shipments: "Jo'natma turlari",
  prohibited_items: "Taqiqlangan joylanmalar",
  domestic_shipments: "O'zbekiston ichidagi jo'natmalar",
  international_shipments: "Xalqaro jo'natmalar",
  tracking_shipments: "Jo'natmani kuzatish",
  hybrid_mail: "Gibrid pochta",
  online_subscriptions: "Gazeta va jurnallarga onlayn obuna",
  view_all: "Barchasini ko'rish",
  cooperating_with_us: "Biz bilan hamkorlik qilmoqda",
  about_multibrand_points: "UzPost multibrend topshirish punktlari haqida",
  multibrand_points_description: "Multibrend topshirish punktlari - bu marketpleys va onlayn-do'kon xaridorlariga buyurtmalarni UzPost bo'limlarida topshirish imkoniyati. UzPost bo'limlari mijozlar uchun yaqin va qulay.",
  multibrand_ordering: "Turli xil bizning hamkor marketpleys/onlayn-do'konlardan UzPost bo'limlarini tablab buyurtma bering",
  uzpost_availability: "UzPost bo'limlari butun O'zbekiston bo'ylab tumanlar miqyosigacha mavjud.",
  convenience_saving: "Agar pochta bo‘limi do‘konlarning alohida topshirish punktlariga qaraganda yaqinroq bo‘lsa, bu vaqt va kuchni tejaydi.",
  cash_on_delivery: "Ba'zi hamkor marketpleys/onlayn-do'konlardan qilingan buyurtmalar uchun to'lovni qabul qilish vaqtida ham amalga oshirsa bo'ladi.",
  central_bank_exchange_rates: "Markaziy bank valyuta kurslari",
  download_app: "Ilovamizni yuklab oling va yangiliklardan xabardor bo'lib turing!",
  app_description: "UzPost mobil ilovasini yuklab oling va qulayliklardan foydalaning!",
  app_platforms: "Ilova App Store va Google Play platformalarida mavjud",
  faq: "Koʻp beriladigan savollar",
  faq_find_branch: "Eng yaqin bo'limni qanday topish mumkin?",
  faq_tariffs: "UzPost xizmatlari tariflari bilan qayerda tanishib chiqsa bo'ladi?",
  faq_tracking: "Jo'natmani qanday kuzatish mumkin?",
  faq_post_index: "Mening indeksim nima?",
  tracking_instruction: "Pochta jo'natmalarini ushbu saytning bosh sahifasida mavjud bo'lgan jo'natmalarni kuzatish funksiyasi orqali jo'natma trek-kodini kiritish yo'li bilan amalga oshirish mumkin.",
  tracking_code_format: "Trek-kod boshida “ikkita harf”, keyin “to'qqizta raqam” va oxirida “ikkita harf” ko'rinishida bo'ladi. Misol uchun, RF270145546CN.",
  tracking_code_types_heading: "Trek kodi harf bilan boshlanadigan jo'natish turlari:",
  tracking_code_type_C: "\"C\" - oddiy posilka (2 kg dan ortiq), yetkazib berilgunga qadar kuzatuv",
  tracking_code_type_R: "\"R\" - mayda paket (2 kg dan kam), yetkazib berilgunga qadar kuzatuv",
  tracking_code_type_L: "\"L\" - mayda paket (2 kg dan kam), yetkazib berilgunga qadar kuzatuv, qabul qiluvchi mamlakatning pochta operatori orqali qidirilmaydi",
  tracking_code_type_E: "\"E\" - tezkor jo'natish (EMS), ikkinchi harf tartibli hisoblanib, yetkazib berilgunga qadar kuzatuv",
  tracking_code_type_V: "\"V\" - sug'urtali xat",
  tracking_code_type_A: "\"A\" - mayda paket, qabul qiluvchi mamlakat tomonidan kuzatilmaydi, qabul qiluvchi mamlakatning pochta operatori orqali qidirilmaydi",
  tracking_code_type_U: "\"U\" - mayda paket, qabul qiluvchi mamlakat tomonidan kuzatilmaydi, qabul qiluvchi mamlakatning pochta operatori orqali qidirilmaydi",
  tracking_code_type_Z: "\"Z\" - mayda paket, qabul qiluvchi mamlakat bo'yicha qisman kuzatuv (faqat qabul qiluvchining pochta bo'limiga kelganligi haqida ma'lumot)",
  management_bodies: "Boshqaruv organlari",
  management_effectiveness: "Samarali boshqaruv kompaniyaning jadal rivojlanish kalitidir",
  management_description: "\"O'zbekiston pochtasi\" AJ rahbariyati zamon bilan hamnafas bo'lib, aholiga sifatli xizmat ko'rsatishni ta'minlash maqsadida xalqaro tajribadan foydalanib, ilg'or texnologiyalarni joriy qilmoqda.",
  management_bodies_list: "Boshqaruv organlari:",
  executive_bodies: "Ijro etuvchi organlar",
  supervisory_board: "Kuzatuv kengashi",
  audit_commission: "Taftish komissiyasi",
  internal_audit_service: "Ichki audit xizmati",
  corporate_consultant: "Korporativ maslahatchi",
  mark_catalog: "Markalar katalogi",
  executive_apparatus: "Ijroiya apparati",
  phone_number: "Telefon raqam:",
  fax: "Fax:",
  reception_days: "Qabul kunlari:",
  reception_hours: "Qabul vaqti:",
  faizyullaev_alisher: "Fayzullayev Alisher Nasibullayevich",
  faizyullaev_alisher1: "Bosh direktor",
  faizyullaev_alisher2: "1966-yil 24-sentabrda Toshkent shahrida tug‘ilgan. Millati o‘zbek. 1988-yilda Toshkent aloqa elektrotexnika institutini bitirgan. 2019-yil 12-iyuldan boshlab “O‘zbekiston pochtasi” AJ bosh direktor lavozimida faoliyat yuritmoqda.",
  faizyullaev_alisher3: "Dushanba.",
  dadamuxamedov_rustam: "Dadamuxamedov Rustam Abdugapparovich",
  dadamuxamedov_rustam1: "Moliya bo'yicha direktor",
  dadamuxamedov_rustam2: "1976-yil 29-yanvarda Toshkent shahrida tug‘ilgan. Millati o‘zbek. 1998-yilda Toshkent elektrotexnika aloqa institutini bitirgan. O‘zbekiston Respublikasi Liberal-demokratik partiyasi a’zosi. 2019-yil 24-maydan boshlab “O‘zbekiston pochtasi” AJ moliya bo'yicha direktor lavozimida faoliyat yuritmoqda.",
  dadamuxamedov_rustam3: "Chorshanba.",
  xusyayenova_noila: "Xusyayenova Noila Garifovna",
  xusyayenova_noila1: "Ishlab chiqarish bo'yicha direktor",
  xusyayenova_noila2: "1975-yil 15-iyunda Toshkent shahrida tug‘ilgan. Millati tatar. 2006-yilda Al-Xorazmiy nomidagi Toshkent axborot texnologiyalari universitetini tamomlagan. 2022-yil 29-iyuldan boshlab “O‘zbekiston pochtasi” AJ ishlab chiqarish bo'yicha direktor lavozimida faoliyat yuritib kelmoqda.",
  xusyayenova_noila3: "Seshanba.",
  nugmanov_taxir: "Nugmanov Taxir Tulkunovich",
  nugmanov_taxir1: "Pochta xavfsizligi bo'yicha direktor",
  nugmanov_taxir2: "1975-yil 8-noyabrda Toshkent viloyatida tug‘ilgan. Millati o‘zbek. 1999-yilda Toshkent davlat texnika universitetini tamomlagan. 2023-yil 28-sentyabrdan “O‘zbekiston pochtasi” AJ pochta xavfsizligi bo‘yicha direktor lavozimida ishlab kelmoqda.",
  nugmanov_taxir3: "Juma.",
  marka_sana: "Chiqarilgan sana",
  marka_addadi: "Addadi",
  marka_nominal: "Nominal",
  marka_haqida: "MARKA HAQIDA MA'LUMOT",
  sections_map: "Bo'limlar xaritasi",
  services_rates: "Xizmatlar tariflari bilan bu yerda tanishishingiz mumkin!",
  department_index: "Siz belgilangan manzilga xizmat ko'rsatadigan bo'lim indeksini bu yerda aniqlashingiz mumkin",
  my_index: "MENING INDEKSIM",
  contact_us: "Aloqa uchun",
  address: "Yunusobod tumani, Oloy ko'chasi, 1-uy",
  subscribe_us: "Bizga obuna bo'ling",
  subscribe_info: "Bizning eng so'nggi yangiliklarimizdan xabardor bo'lib turish uchun obuna bo'ling",
  welcome: "Xush kelibsiz!",
  edit: "Tahrirlash",
  my_account: "Hisobim",
  profile: "Profil",
  send_request: "Murojaat yuborish",
  chat: "Chat",
  marks_catalog: "Markalar katalogi",
  min_year: "Yildan",
  max_year: "Yilgacha",
  filter: "Filter",
  jamiyat: "“O‘zbekiston pochtasi” aksiyadorlik jamiyati",
  all: "Barchasi",
  login: "Kirish",
  login_prompt: "Quyidagi maydonlarni to'ldirib tizimga kiring.",
  enter_phone: "Telefon raqamingizni kiriting",
  enter_password: "Parolingizni kiriting",
  have_account: "Hisobingiz bormi?",
  register: "Kabinet",
  error: "Xatolik",
  close: "Yopish",
  invalid_login: "Login yoki parol noto'g'ri.",
  sign_up: "Ro'yxatdan o'tish",
  verify_phone: "Telefon raqamingizni kiriting va SMS orqali tasdiqlang",
  phone_number1: "Telefon raqamingiz",
  sms_sent: "Raqamga SMS kod yubordik",
  your_name: "Ismingiz",
  enter_your_name: "Ismingizni kiriting",
  enter_password1: "Parolni kiriting",
  password: "Parol",
  repeat_password: "Parolni takrorlang",
  reenter_password: "Parolni qayta kiriting",
  have_account1: "Hisobingiz bormi?",
  leave_comment: "Izoh qoldiring",
  name: "Ism",
  enter_name: "Ismingizni kiriting",
  phone: "Telefon",
  enter_phone1: "Telefon raqamingizni kiriting...",
  comment: "Izoh",
  leave_comment1: "Izoh yozib qoldiring",
  uzpost_contact: "UzPost bilan bog'lanish",
  contact_types: "Biz bilan bog'lanish turlari:",
  phone_number2: "Telefon raqam",
  email: "E-mail:",
  address1: "Manzil:",
  yunusobod_address: "Yunusobod tumani, Oloy ko'chasi, 1-uy",
  submit_question: "Savol, murojaat yoki takliflarni yuborish",
  applicant: "Murojaatchi",
  email_placeholder: "Email manzilingizni kiriting",
  phone_placeholder: "Telefon raqamingizni kiriting",
  attach_file: "Faylni biriktirish",
  message_text: "Murojaat matni",
  message_placeholder: "Savol, murojaat yoki taklifni kiriting...",
  submit_button: "Xabar yuborish",
  file: "Fayl",
  questions_suggestions: "Savollar va takliflar",
  official_letters: "Rasmiy xatlar va murojaatlar",
  calculator: "Kalkulyator",
  place_parcel: "Posilka yoki xatni joylashtiring",
  calculate_time_cost: "Xarajatlarni va etkazib berish vaqtini hisoblang",
  parcel_info: "Posilka — bu jo'natishga ruxsat etilgan sanoat tovarlari, oziq-ovqat mahsulotlari, madaniy-maishiy va boshqa tovarlar solingan pochta jo'natmasi turi.",
  parcel_small_info: "Mayda paketlar — kichik va sinmaydigan predmetlarni jo’natishning qulay usulidir. Ushbu jo'natma turida kiyim-kechak, aksessuarlar va boshqa kichik sinmaydigan mahsulotlarni yuborish mumkin.",
  letter_info: "Xat - bu ichida yozma xat-xabar, hujjatlar bo’lgan pochta jo'natmasi",
  bir_qadam_info: "“Bir Qadam” xizmati orqali jo'natmalaringizni 1 KUNda butun O'zbekiston bo'ylab belgilangan bo'limlar orasida yetkazib beramiz.",
  from_where: "Qayerdan",
  choose_region: "Viloyat tanlang",
  choose_district: "Tuman tanlang",
  address2: "Manzil",
  sender_address: "Jo'natuvchining shaharini yoki manzilini kiriting.",
  to_where: "Qayerga",
  index: "Indeks",
  recipient_address: "Manzil",
  postomat: "Pochtomat",
  other_countries: "Boshqa mamlakatga",
  enter_index: "Indeksni kiriting",
  index_note: "Indeks bu jo'natish faqat O'zbekiston bo'ylab mavjud. Jo'natma talab qilib olingandan so'ng yetkaziladi. Qabul qiluvchi jo'natma kelganligini tasdiqlash uchun trek-raqamini qabul qiluvchiga yuboring.",
  weight: "Og'irligi",
  size: "Hajmi",
  choose_weight_unit: "gramm",
  choose_size: "Tanlang",
  calculate: "Hisoblash",
  cost_estimation: "Yuk tashish vaqtlari va xarajatlarini hisoblash uchun shaklni to‘ldiring",
  approximate_cost: "Taxminan:",
  create_order: "Buyurtmani yaratish",
  uzpost_branches: "UzPost filiallari",
  branches: "Filiallar",
  branch_working_hours: "Filialning ish vaqti:",
  address3: "Manzil:",
  not_robot: "Men robot emasman",
  accept_terms: "Robot emasligingizni tasdiqlang",
  privacy_policy: "Maxfiylik siyosati",
  help_support: "Yordam & Qo'llab-quvvatlash",
  terms_conditions: "Shartlar & Qoidalar",
  latest_news: "So'nggi yangiliklar",
  search: "Izlash",
  categories: "Kategoriyalar",
  community_news: "Jamiyat yangiliklari",
  service_news: "Xizmatlar va tariflar yangiliklari",
  official_statements: "Rasmiy munosabatlar",
  department_news: "Bo'limlar yangiliklari",
  partnership_news: "Hamkorlik yangiliklari",
  social_projects: "Ijtimoiy loyihalar",
  Host_Country: "Qabul qiluvchi mamlakats",
  Address: "Manzil",
  service_unavailable: "Bu xizmat hozircha mavjud emas",
  summ: "so'm",
  yil: "Yillar",
  turkum: "Turkumlar",
  stated_amount_may: "Yuqoridagi summa berilgan og'irlikka nisbatan o'zgarishi mumkin.",
  Error_in_price: "Narxni hisoblashda xatolik!",
  package_weight: "Posilka xizmatida vazni 30 kgdan oshmasligi kerak!",
  package_weight_small: "Mayda paket vazni 2kg dan oshmasligi kerak!",
  letter_weight: "Xat vazni 2kg dan oshmasligi kerak!s",
  parcel_single: "Bir qadam vazni 20 kgdan oshmasligi kerak!",
  Fill_in_all: "Barcha maydonlarni to'ldiring",
  Place_package_letter: "Posilka yoki xatni joylashtiring",
  Calculate_cost_time: "Xarajatlarni va yetkazib berish vaqtini hisoblang",
  from: "Kimdan",
  from1: "F.I.Sh",
  to_whom: "Kimga",
  enter_city_address: "Jo‘natuvchining shaharini yoki manzilini kiriting.",
  address_note: "Aniqroq hisob-kitob uchun to‘liq manzilni kiriting",
  place_order: "Buyurtma yaratish",
  branch_Contact: "O'zingizga yaqin aloqa bo'limiga murojaat qiling",
  This_barcode: "Ushbu shtrix kodni",
  Deliver_shipment: "jo‘natma bilan birgalikda o‘zingizga yaqin aloqa bo‘limiga yetkazing",
  Order_created: "Buyurtma yaratildi!",
  error_occurred: "Buyurtma yaratishda xatolik yuz berdi.",
  Release_date: "Chiqarilgan sana",
  Quantity: "Addadi",
  Nominal: "Nominal",
  stamp_info: "Marka haqida ma'lumot",
  logout: "Kabinetdan chiqish",
  edit_profile: "Profilni tahrirlash",
  process_shipment: "Jo'natmani rasmiylashtirish",
  my_shipments: "Mening jo'natmalarim",
  or: "Yoki",
  user_info: "Foydalanuvchi ma'lumotlari",
  your_gender: "Jinsingiz:",
  gender1: "Erkak",
  gender2: "Ayol",
  your_address: "Manzilni tanlang:",
  your_address1: "Manzilni kiriting:",
  your_region: "Viloyat:",
  your_district: "Tuman:",
  your_postal_code: "Pochta indeksi:",
  enter_postal_code: "Indeks raqamini kiriting:",
  save: "Saqlash",
  delete: "O‘chirish",
  delete_profile: "Profilingizni o‘chirish",
  mal: "Profilingizni o‘chirib tashlaganingizda profil xizmatlaridan foydalana olmaysiz va biz butunlayo‘chirib tashlaymiz. O‘chirish jarayonini 14 kun ichida bekor qilishingiz mumkin.",
  tasdiq: "Profili o‘chirib tashlanishini tasdiqlayman.",
  access_legal_entity_profile: "Yuridik shaxs profiliga kirish",
  contract_processing: "Shartnomalarni rasmiylashtirish",
  processing: "Rasmiylashtirish",
  about_partnership: "Hamkorlik haqida",
  make_business_successful: "Keling, biznesingizni yanada muvaffaqiyatli qilamiz!",
  mutually_beneficial_partnership: "Pochta xizmatimiz bilan o‘zaro manfaatli hamkorlik qilish imkoniyatini taklif etishdan mamnunmiz. Biznesingiz uchun samarali logistika va ishonchli yetkazib berish qanchalik muhimligini tushunamiz va sizga ehtiyojlaringizga moslashtirilgan keng ko‘lamli xizmatlarni taklif qilishga tayyormiz.",
  parcel: "Posilka",
  Small_packages: "Mayda paketlar",
  letter: "Xat",
  kuzatuv: "Kuzatuv",
  guest: "Mehmon",
  reset_password: "Parolni tiklash",
  form_submission_failed: "Murojaatingizni yuborishda xatolik yuz berdi",
  form_submitted_successfully: "Murojaatingiz muvoffaqqiyatli yuborildi",
  page_not_found: "Oops! Sahifa topilmadi",
  contact_us_if_problem: "Muammo bo'lsa bizga murojaat qiling",
  go_to_homepage: "Bosh sahifaga o'tish",
  no_data_found: "Xatolik",
  price_calculation_failed: "Narxni hisoblashda xatolik!",
  parcel_weight_exceeded: "Posilka xizmatida vazni 30 kgdan oshmasligi kerak!",
  small_packet_weight_exceeded: "Mayda paket vazni 2kg dan oshmasligi kerak!",
  letter_weight_exceeded: "Xat vazni 2kg dan oshmasligi kerak!",
  single_step_weight_exceeded: "Bir qadam vazni 20 kgdan oshmasligi kerak!",
  fill_all_fields: "Barcha maydonlarni to'ldiring",
  region: "Viloyat",
  district: "Tuman",
  street: "Ko'cha",
  working_hours: "Ish vaqti",
  location: "Joylashuv",
  sender: "Yuboruvchi",
  country: "Mamlakat:",
  address5: "Manzil:",
  postal_code: "Pochta indeksi:",
  receiver: "Qabul qiluvchi",
  save_password: "Parolni saqlash",
  verify: "Tasdiqlash",
  request_sms_code: "SMS kodini so'rang",
  order_number: "Buyurtma raqami",
  shipment_type: "Jo'natma turi",
  delivery_address: "Yetkazib berish manzili",
  created_date: "Yaratilgan sana",
  price: "Narxi",
  status: "Status",
  phone_not_registered: "Bu telefon raqami ro'yxatdan o'tmagan!",
  too_many_attempts: "Siz juda ko‘p urinish qildingiz. Iltimos, birozdan keyin qayta urinib ko‘ring!",
  network_error: "Tarmoq xatosi. Iltimos, internet ulanishingizni tekshiring va qayta urinib ko‘ring.",
  ok: "OK",
  password_error: "Parolni to'g'ri takrorlanganligini tekshiring",
  hudud: "Hudud",
  shahar: "Shahar",
  uy: "Uy",
  Geolokatsiya: "Geolokatsiya",
  korish: "Ko'rish",
  izlashkocha: "Ko'cha yoki mahalla nomini kiriting",
  oddiy: "Oddiy ko'rinish",
  rangsiz: "Rangsiz ko'rinish",
  manzilbilan: "Manzil bilan izlash",
  bolimizlash: "Indeks bilan izlash",
  mahallanomi: "Manzilni kiriting",
  aloqanomi: "Pochta bo'limi indeksini kiriting",
  yur: "UzPost'ning mavjud xizmatlari bo'yicha yuridik shaxs sifatida hamkorlik qilish uchun uzpost.business@gmail.com elektron pochtasiga yoki 55-520-02-70 telefon raqami orqali hamkorlik tafsilotlari bilan murojaat qoldiring!",
  experience: "Tajriba",
  vacancies: "Vakansiyalar",
  open_vacancies: "Ochiq vakansiyalar",
  select_interesting_vacancy: "O‘zingizga qiziq bo‘lgan vakansiyani tanlang va rezyumeingizni qoldiring",
  experience1: "Ish tajribasi",
  department: "Bo'lim",
  apply: "Qo‘llash",
  clear: "Tozalash",
  salary: "Maosh",
  select_branch: "Filialni tanlang",
  save_and_continue: "Saqlash va davom etish",
  cancel: "Bekor qilish",
  details: "Batafsil",
  fill_application: "Ariza to'ldirish",
  full_name: "F.I.Sh",
  enter_full_name: "Familiyangiz, ism-sharifingizni kiriting",
  about_yourself: "O'zingiz haqingizda qisqacha ma'lumot qoldiring",
  description_hint: "Ma'lumotingiz, tajribangiz, shaxsiy yutuqlaringiz va boshqalar.",
  write_text: "Matn yozing",
  upload_resume: "Rezyumeni yuklang",
  max_files_hint: "Maksimal 50 MB hajmli 5 tagacha fayl biriktiring",
  upload_file: "Faylni yuklash",
  save1: "Saqlash",
  contact_info: "Bog'lanish uchun kontakt ma'lumotlaringizni qoldiring",
  phone_number3: "Telefon raqam",
  additional_phone: "Telefon raqam (qo'shimcha)",
  enter_phone2: "Telefon raqamingizni kiriting",
  additional: "Qo‘shimcha ravishda",
  enter_email: "Email manzilingizni kiriting...",
  save_and_send: "Saqlash va jo‘natish",
  go_back: "Ortga qaytish",
  lets_get_acquainted: "Keling tanishaylik!",
  uzpost_contact_notice: "Tez orada UzPost mas'ul xodimlari siz bilan bog'lanishlari mumkin.",
  language1: "Til",
  map1: "Xarita",
  help1: "Yordam",
  accessibility: "Maxsus imkoniyatlar",
};